// Input para formularios
import React from "react";
import TextField from '@material-ui/core/TextField';
import * as FxLog from '../fx/FxLog';
import CxIconButton from "./CxIconButton";
import '../../styles/main.css';
import { useStyles } from "./StylesCx";
import * as FxControl from '../fx/FxControl';

const CxFile = props => {
  const classes = useStyles(props);
  const {
    onChange,
    onClear,
    onLoad,
    InputLabelProps,
    label,
    labelTooltip,
    fileTypes,   // NUEVO: filtros tipo ['pdf','jpg','png'] o ['.pdf','.jpg']
    ...rest
  } = props;

  const [myFile, setMyFile] = React.useState(null);
  const [myFileName, setMyFileName] = React.useState('');
  const [isRequired, setIsRequired] = React.useState(false);

  // Construye el "accept" HTML a partir de un array de tipos/extensiones
  const buildAcceptFromFileTypes = (arrFileTypes) => {
    if (!arrFileTypes || arrFileTypes.length === 0) return undefined;

    const arrClean = arrFileTypes
      .map((strType) => {
        const strTrim = (strType || '').trim();
        if (strTrim === '') return null;

        if (strTrim.startsWith('.') || strTrim.includes('/')) return strTrim;

        return `.${strTrim}`;
      })
      .filter(Boolean);

    if (arrClean.length === 0) return undefined;
    return arrClean.join(',');
  };

  const initialAccept =
    rest.accept !== undefined
      ? rest.accept
      : buildAcceptFromFileTypes(fileTypes);

  const [accept, setAccept] = React.useState(initialAccept);

  const rf_inputfile = React.useRef(null);

  React.useEffect(() => {
    setIsRequired(props.required);
    if (onLoad) onLoad();
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    if (onChange !== undefined) onChange(); 
    // eslint-disable-next-line
  }, [myFile]);

  React.useEffect(() => {
    const newAccept =
      rest.accept !== undefined
        ? rest.accept
        : buildAcceptFromFileTypes(fileTypes);
    setAccept(newAccept);
  }, [rest.accept, fileTypes]);

  React.useImperativeHandle(props.xref, () => {
    return {
      getType,
      setFile,
      getFile,
      setFileName,
      getIsRequired,
      getLabel,
      clear,
      isEmpty,
      setAccept, 
    };
  });

  const setFile = (newFile) => { setMyFile(newFile); };
  const setFileName = (newFileName) => { setMyFileName(newFileName); };
  const getFile = () => { return myFile; };
  const getIsRequired = () => {
    return isRequired && (getFile() === null || (getFile() || '').length === 0);
  };
  const getLabel = () => { return props.label; };
  const isEmpty = () => { return myFile === null; };
  const getType = () => { return 'CxFile'; };

  const clear = () => {
    FxLog.infox("CxFile.clear", "...");
    if (!props.readOnly && !props.disabled) {
      setMyFile(null);
      setMyFileName('');
      
      // ¡SOLUCIÓN AQUÍ! Limpiamos el input nativo del navegador
      if (rf_inputfile && rf_inputfile.current) {
        rf_inputfile.current.value = '';
      }

      if (onClear) onClear();
    }
  };

  const search = async () => {
    if (!props.readOnly && !props.disabled) {
      rf_inputfile.current.click();
    }
  };

  const onChangeFile = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const file = event.target.files[0];
    if (file) {
      setFile(file);
      setFileName(file.name);
    }
  };

  return (
    <div className={classes.frame}>
      <input
        type="file"
        accept={accept} 
        ref={rf_inputfile}
        style={{ display: "none" }}
        onChange={onChangeFile}
      />
      <div className={classes.frame_content}>
        <TextField
          minRows={props.minRows}
          multiline={props.minRows !== undefined ? true : false}
          className={classes.control}
          label={FxControl.getLabel(label, isRequired, labelTooltip)}
          InputLabelProps={{
            required: false,
            classes: { root: classes.root },
            shrink: true,
            ...InputLabelProps
          }}
          InputProps={{
            disableUnderline: true,
            required: false,
            classes: { root: classes.root },
            inputProps: {
              style: { cursor: 'default' },
              maxLength: props.maxLength,
              readOnly: true,
            },
          }}
          value={myFileName || ''}
          onClick={() => search()} 
          {...rest}
        />
      </div>

      <div className={classes.frame_buttons}>
        {!props.readOnly && (
          <CxIconButton
            type="clear"
            classType={classes.frame_icons}
            onClick={clear}
            disabled={props.disabled}
          />
        )}
        {!props.readOnly && (
          <CxIconButton
            type="search"
            classType={classes.frame_icons}
            onClick={() => search()}
            disabled={props.disabled}
          />
        )}
      </div>
    </div>
  );
};

export default CxFile;